module.exports = __webpack_public_path__ + "static/media/hashtag-nft-23.b9bfcd7b.jpg";